import authHeader from "./auth-header";
import axios from "axios";
import { API_URL } from "./constants.service";

class CorporationDataService {
  // Get all corporations from the database
  getAll(filter) {
    return axios.post(API_URL + "/corporations", filter, { headers: authHeader() });
  }

  // Create a new corporation
  create(data) {
    return axios.post(API_URL + "/corporation", data, { headers: authHeader() });
  }

  // Get just one corporation
  get(id) {
    return axios.get(API_URL + `/corporation/${id}`, { headers: authHeader() });
  }

  // Delete a specific corporation out of the table.
  delete(id) {
    return axios.delete(API_URL + `/corporation/${id}`, { headers: authHeader() });
  }

  // Update the data of one specific corporation.
  update(id, data) {
    return axios.put(API_URL + `/corporation/${id}`, data, {
      headers: authHeader(),
    });
  }

  // Check if the choosen id exists
  idExists(id) {
    return axios.get(API_URL + `/corporation/id-exists/${id}`, { headers: authHeader() });
  }
}

export default new CorporationDataService();